import BaseError from "./BaseError";

class InternalServerError extends BaseError {
  public status = "internal_server_error";

  public code = 500;
}

export default InternalServerError;
